import React from 'react';
import { RiGraduationCapLine, RiCodeSSlashLine, RiLightbulbLine, RiFileList3Line } from 'react-icons/ri';

const AboutBox = () => {
    return (
        <div className="about__boxes grid">
            <div className="about__box">
                <RiGraduationCapLine className="about__icon" />
                <div>
                    <h3 className="about__title">2025</h3>
                    <span className="about__subtitle">Graduated BRAC University</span>
                </div>
            </div>

            <div className="about__box">
                <RiCodeSSlashLine className="about__icon" />
                <div>
                    <h3 className="about__title">40+</h3>
                    <span className="about__subtitle">GitHub Repositories</span>
                </div>
            </div>

            <div className="about__box">
                <RiLightbulbLine className="about__icon" />
                <div>
                    <h3 className="about__title">10+</h3>
                    <span className="about__subtitle">Completed Projects</span>
                </div>
            </div>

            <div className="about__box">
                <RiFileList3Line className="about__icon" />
                <div>
                    <h3 className="about__title">1</h3>
                    <span className="about__subtitle">IEEE Publication</span>
                </div>
            </div>
        </div>
    );
}

export default AboutBox;
